import { withUserInputs } from "./withUserInputs/withUserInputs";
import { withOriginalValues } from "./withOriginalValues/withOriginalValues";
import { countSuppliersWithEligibleProducts } from "./suppliersWithEligibleProducts/suppliersWithEligibleProducts";
import { ELIGIBLE_ORDERS_STRATEGY_VALUES } from "../../../components/components.constants";

export { withUserInputs, withOriginalValues, countSuppliersWithEligibleProducts };

const eligibilityStrategies = {
  [ELIGIBLE_ORDERS_STRATEGY_VALUES.WITH_USER_INPUTS]: withUserInputs,
  [ELIGIBLE_ORDERS_STRATEGY_VALUES.API_DATA]: withOriginalValues,
  [ELIGIBLE_ORDERS_STRATEGY_VALUES.ELIGIBLE_ORDERS]: countSuppliersWithEligibleProducts,
};

export const getPurchaseOrderEligibility = (mode, args) => {
  const strategy = eligibilityStrategies[mode];
  if (!strategy) throw new Error(`[getPurchaseOrderEligibility] Unknown mode: "${mode}"`);
  return strategy(args);
};